export const MAP_RTL_CODE =
  "https://api.mapbox.com/mapbox-gl-js/plugins/mapbox-gl-rtl-text/v0.2.3/mapbox-gl-rtl-text.js";
export const MAP_TOKEN =
  "pk.eyJ1IjoiZmF0ZW1laGVpc2EiLCJhIjoiY2tweHI0ZzFqMDNqYjJ4bnU2Y3R4Mjd6NSJ9.uYddP7wRuwsGtaU7qQ7yRg";
export const SITE_KEY_VALUE = "6LencMwZAAAAAMmH30PRhfwYHh3-krnKEaeauuhn";
export const DELAY_OF_GEETING_TOKEN = 60000;
export const DELAY_OF_GEETING_TOKEN_IN_CATCH = 20000;
export const ANALYTICS_ID = "UA-173952483-1";
export const FREIND_REFERRAL =
  "https://coinnik.market/app/markets/BTC_TMN?ref=";
export const COINNIK_MARKET_APP_URL = "https://coinnik.market/app/";
export const COINNIK_MARKET_BASE_TOKEN = "BTC_TMN";
export const COINNIK_MARKET_URL_BASE_TOKENS =
  "https://coinnik.market/app/markets/";
export const COINNIK_MARKET_BLOG = "https://blog.coinnik.market/";
export const COINNIK_MARKER_LINKDIN =
  "https://www.linkedin.com/company/coinnikmarket";
export const COINNIK_MARKER_INSTAGRAM =
  "https://www.instagram.com/coinnikmarket/";
export const COINNIK_MARKER_TWITTER = "https://twitter.com/coinnikmarket";
export const COINNIK_MARKET_MAIL = "mailito: info@coinnik.market";
